import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const titles = {
  "/": "Home",
  "/login": "Login",
  "/dashboard": "Dashboard",
  "/dashboard/attendance": "Attendance",
  "/dashboard/list": "Master Data List",
  "/dashboard/invoice-report": "Invoice Report",
  "/dashboard/manage-students": "Manage Students",
  "/dashboard/manage-staffs": "Manage Staffs",
  "/dashboard/admin-config": "Admin Configuration",
};

const PageTitleManager = () => {
  const location = useLocation();

  useEffect(() => {
    const baseTitle = "FeeZaap";
    const title = titles[location.pathname] || "FeeZaap";
    document.title = `${title} | ${baseTitle}`;
  }, [location.pathname]);

  return null;
};

export default PageTitleManager;
